import { defa }          from 'defa-object';
import { WeeklyProgram } from 'scripts/utils/weekly-program';
import ControlModel      from 'scripts/poppet/control-model';

/**
 * defa.models.PickupTime
 * The DEFA PickupTime model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	warmup: '/warmUp/warmUp?attrs=',
};


const PickupTime = ControlModel.extend( {

	url: function() {
		return api.linkcom + this.get('id') + api.warmup + this.getAttributes();
	},
	
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({}, ControlModel.prototype.defaults,
		{
			weeklyProgram: [
		// {
		//     enabled: null,
		//     timestamp: '00:00Z' or '00:00+01' // Only from backend
		//     time: '00:00',                    // Time in the given timezoneOffset
		//     days: [],
		//     preheating: 0
		// }
			],
		
			weeklyProgramError: null,
			weeklyProgramDisabled: true,
		
			singleEvents: [
			 //{enabled: true, activated: false, cancelled: false, time: '2018-10-01T13:37Z'}
			],

		// maxCount The maximum number of weeklyPrograms
			maxCount: 6,

		//The timezone of the 'time' parameters
			timezoneOffset: null,
		}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	parse: function( response, options ) {
		//Do a check to decide if response is valid for parsing
		if(response && response.weeklyProgram) {
			let newModelAttributes = {};

			//In the future, the timezone might be set by the user.
			newModelAttributes.timezoneOffset = new Date().getTimezoneOffset();
			this.parseAttribute('weeklyProgram', response.weeklyProgram, options, newModelAttributes);

			//Parse timestamp to local time and days
			if('success' === response.weeklyProgram.status){
				newModelAttributes.weeklyProgramDisabled = false;
				for (let index in newModelAttributes.weeklyProgram){
					let program = newModelAttributes.weeklyProgram[index];
					let weeklyProgram = WeeklyProgram.fromApi( program );
					let localProgram = weeklyProgram.toOffset( newModelAttributes.timezoneOffset );
					
					program.time = localProgram.time;
					program.days = localProgram.getApiDays();
				}
			}
			
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'pickupTimes' ).add( newModelAttributes, { merge: true } );
		}
	},

	
	toBackendJSON: function() {
		let backendModel = { weeklyProgram: [], };
		backendModel.weeklyProgram = this.get('weeklyProgram');

		//Set correct timestamp in local timeoffset
		for(let index in backendModel.weeklyProgram) {
			let program = backendModel.weeklyProgram[index];

			//Get timestamp for timezoneOffset
			program.timestamp = WeeklyProgram.fromTimeAndOffset( program, this.get('timezoneOffset') ).getTimestamp();
		}

		return backendModel;
	},
	
	attributeToReuqestPayload: function(attribute) {
		let backendModel = {};
		backendModel.weeklyProgram = attribute;
		
		//Set correct timestamp in local timeoffset
		for(let index in backendModel.weeklyProgram) {
			let program = backendModel.weeklyProgram[index];
			
			//Get timestamp for timezoneOffset
			program.timestamp = WeeklyProgram.fromTimeAndOffset( program, this.get('timezoneOffset') ).getTimestamp();
		}
		
		return backendModel;
	},
	
	_getDependentModels: function () {
		let self = this;
		let dependentModels = [];
		dependentModels.push(channel.request( 'warmupStates' ).get(self.get('id')));
		return dependentModels;
	},

	getAttributes: function() {
		return 'weeklyProgram';
	},
	
} );

export default PickupTime;
